<div
  class="h-full w-full flex items-center justify-center"
  style="background-color: var(--app-canvas)"
>
  <div
    fxLayout="row"
    fxLayoutAlign="start center"
    class="absolute top-0 left-0 py-3 px-4 bg-white z-10"
    style="width: 100vw"
  >
    <img
      class="puma-document-logo"
      src="assets/puma-logo.png"
      alt="PUMA"
    />
    <h2 class="title m-0 text-center text-3xl qqmeTxt_2" fxFlex="auto">
      {{ title }}
    </h2>

    <span></span>
  </div>

  <div
    class="bg-white px-10 py-6"
    style="
      border-radius: 12px;
      box-shadow: 0px 4px 8px 0px rgba(12, 44, 108, 0.08);
    "
  >
    <h2 mat-dialog-title class="text-2xl">Enter code to exit</h2>
    <mat-dialog-content>
      <div class="code-input-container">
        <input
          type="text"
          maxlength="1"
          *ngFor="let box of boxes; index as i"
          class="code-box"
          [(ngModel)]="code[i]"
          (keyup)="onInputChange($event, i)"
          (keydown.enter)="submitCode()"
        />
      </div>

      <div class="error-message" *ngIf="isInvalidCode">
        <p class="m-0 text-left">Incorrect code. Try again.</p>
      </div>
    </mat-dialog-content>

    <div class="flex justify-end ">
      <mat-dialog-actions align="end">
        <button
          mat-button
          class="markAs-complete"
          type="button"
          (click)="submitCode()"
        >
          Exit
        </button>
      </mat-dialog-actions>
    </div>
  </div>
</div>
